import { createRouter, createWebHistory } from 'vue-router'

// Layout
import DefaultLayouts from '@/layouts/DefaultLayouts.vue'
import AdminLayouts from '@/layouts/AdminLayouts.vue'
import CustomerLayout from '@/layouts/CustomerLayout.vue'
import Login from '@/pages/Login.vue'
import ActivateAccount from '@/pages/ActivateAccount.vue'

const CustomerDashboard = () => import('@/pages/customer/Dashboard.vue')

const routes = [
  // Public Layout
  {
    path: '/',
    component: DefaultLayouts,
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('@/pages/Home.vue')
      },
      {
        path: 'about',
        name: 'About',
        component: () => import('@/pages/About.vue')
      },
      {
        path: 'how-it-works',
        name: 'HowItWorks',
        component: () => import('@/pages/HowItWorks.vue')
      },
      {
        path: 'contact',
        name: 'Contact',
        component: () => import('@/pages/Contact.vue')
      },
      {
        path: 'terms-of-service',
        name: 'Terms',
        component: () => import('@/pages/Terms.vue')
      },
      {
        path: 'privacy-policy',
        name: 'PrivacyPolicy',
        component: () => import('@/pages/PrivacyPolicy.vue')
      },
      {
        path: 'faq',
        name: 'Faq',
        component: () => import('@/pages/Faq.vue')
      },
      {
        path: 'blog',
        name: 'Blog',
        component: () => import('@/pages/BlogIndex.vue')
      },
      {
        path: 'blog/:slug',
        name: 'BlogDetail',
        component: () => import('@/pages/BlogDetail.vue')
      }
    ]
  },

  // Admin Layout
  {
    path: '/admin',
    component: AdminLayouts,
    meta: {
      requireLogin: true,
      role: 'admin'
    },
    children: [
      {
        path: 'dashboard',
        name: 'AdminDashboard',
        component: () => import('@/pages/admin/Dashboard.vue')
      },
      {
        path: 'announcements',
        name: 'AdminAnnouncements',
        component: () => import('@/pages/admin/announcements/AnnouncementsIndex.vue')
      },
      {
        path: 'users-admin',
        name: 'UsersAdminDashboard',
        component: () => import('@/pages/admin/admin/AdminIndex.vue')
      },
      {
        path: 'users',
        name: 'UserDashboard',
        component: () => import('@/pages/admin/user/UserIndex.vue')
      },
      {
        path: 'products',
        name: 'Products',
        component: () => import('@/pages/admin/product/ProductIndex.vue')
      },
      {
        path: 'product-types',
        name: 'ProductTypes',
        component: () => import('@/pages/admin/product-types/ProductTypesIndex.vue')
      },
      {
        path: 'landing-pages',
        name: 'LandingPages',
        component: () => import('@/pages/admin/landing-pages/LandingPageIndex.vue')
      },
      {
        path: 'landing-pages-template',
        name: 'LandingPagesTemplate',
        component: () => import('@/pages/admin/landing-pages-template/LandingPagesTemplateIndex.vue')
      },
      {
        path: 'landing-pages-template/:slug/preview',
        name: 'admin-landing-template-preview',
        component: () => import('@/pages/admin/landing-pages-template/LandingPagesTemplatePreview.vue')
      },
      {
        path: 'landing-pages-template/:slug/edit',
        name: 'admin-landing-template-edit',
        component: () => import('@/pages/admin/landing-pages-template/LandingPagesTemplateEdit.vue')
      },
      {
        path: 'blog/posts',
        name: 'AdminBlogPosts',
        component: () => import('@/pages/admin/blog/BlogIndex.vue')
      },
      {
        path: 'blog/categories',
        name: 'AdminBlogCategories',
        component: () => import('@/pages/admin/blog/categories/BlogCategoryIndex.vue')
      },
      {
        path: 'blog/tags',
        name: 'AdminBlogTags',
        component: () => import('@/pages/admin/blog/tags/BlogTagIndex.vue')
      },
      {
        path: 'notifications',
        name: 'admin-notifications',
        component: () => import('@/pages/admin/NotificationsPage.vue')
      },
      {
        path: 'profile',
        name: 'admin-profile',
        component: () => import('@/pages/admin/ProfileIndex.vue')
      },
      {
        path: 'settings/general',
        name: 'admin-settings-general',
        component: () => import('@/pages/admin/settings/GeneralSettings.vue')
      },
      {
        path: 'settings/appearance',
        name: 'Adminappearance',
        component: () => import('@/pages/admin/settings/ThemeSettings.vue')
      },
      {
        path: 'support/messages',
        name: 'AdminSupportMessages',
        component: () => import('@/pages/admin/support/SupportMessagesIndex.vue')
      },
      {
        path: 'support/messages/:id',
        name: 'AdminSupportMessageDetail',
        component: () => import('@/pages/admin/support/SupportMessageDetail.vue')
      }
    ]
  },

  // Customer Layout
  {
    path: '/customer',
    component: CustomerLayout,
    meta: {
      requireLogin: true,
      role: 'customer'
    },
    children: [
      {
        path: 'dashboard',
        name: 'CustomerDashboard',
        component: CustomerDashboard
      },
      {
        path: 'landing-pages',
        name: 'customer-landing-pages',
        component: () => import('@/pages/customer/LandingPage.vue')
      },
      {
        path: 'landing-page-studio/:id',
        name: 'customer-landing-page-editor',
        component: () => import('@/pages/customer/landing-page-editor/LandingPageEditor.vue'),
        props: true
      },
      {
        path: 'settings/security',
        name: 'Security',
        component: () => import('@/pages/customer/Security/CustomerSecurity.vue')
      },
      {
        path: 'settings/appearance',
        name: 'appearance',
        component: () => import('@/pages/customer/settings/ThemeSettings.vue')
      },
      {
        path: 'notifications',
        name: 'customer-notifications',
        component: () => import('@/pages/customer/NotificationsPage.vue')
      },
      {
        path: 'settings/activity',
        name: 'ActivityLog',
        component: () => import('@/pages/customer/Security/CustomerActivityLog.vue')
      },
      {
        path: 'help/support',
        name: 'CustomerSupport',
        component: () => import('@/pages/customer/help/CustomerSupport.vue')
      },
      {
        path: 'profile',
        name: 'customer-profile',
        component: () => import('@/pages/customer/ProfileIndex.vue'),
        meta: {
          requiresAuth: true,
          role: 'customer'
        }
      }
    ]
  },

  // Auth
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      guestOnly: true
    }
  },
  {
    path: '/activate-account',
    name: 'ActivateAccount',
    component: ActivateAccount,
    meta: {
      guestOnly: true
    }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('@/pages/ForgotPassword.vue')
  },
  {
    path: '/verify-reset-otp',
    name: 'VerifyResetOtp',
    component: () => import('@/pages/VerifyResetOtp.vue')
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('@/pages/ResetPassword.vue')
  },
  {
    path: '/verify-email-change',
    name: 'VerifyEmailChange',
    component: () => import('@/pages/VerifyEmailChange.vue')
  },

  // Public Landing Page (dynamic)
  {
    path: '/:typeSlug/:landingSlug',
    name: 'PublicLandingPage',
    component: () => import('@/pages/PublicLandingPage.vue')
  },

  // 404
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/pages/NotFound.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

// Navigation Guard — auth & role
router.beforeEach((to, from, next) => {
  let user = null

  try {
    user = JSON.parse(sessionStorage.getItem('user') || 'null')
  } catch (error) {
    sessionStorage.removeItem('user')
  }

  const token = sessionStorage.getItem('token')

  if (to.matched.some((route) => route.meta.requireLogin)) {
    if (!token || !user) {
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('user')

      return next({
        name: 'Login',
        query: { redirect: to.fullPath }
      })
    }

    const requiredRole = to.meta.role

    if (requiredRole && user.role !== requiredRole) {
      if (user.role === 'admin') {
        return next({ name: 'AdminDashboard' })
      }

      if (user.role === 'customer') {
        return next({ name: 'CustomerDashboard' })
      }

      return next({ name: 'Login' })
    }
  }

  if (to.meta.guestOnly && token && user) {
    if (user.role === 'admin') {
      return next({ name: 'AdminDashboard' })
    }

    if (user.role === 'customer') {
      return next({ name: 'CustomerDashboard' })
    }
  }

  next()
})

/**
 * afterEach minimal — hanya handle <meta name="robots">.
 *
 * Title, description, canonical, og:*, twitter:* di-handle oleh
 * useSeo() di masing-masing page (via @unhead/vue). Jangan set
 * document.title di sini agar tidak menimpa useSeo().
 */
router.afterEach((to) => {
  let robotsTag = document.querySelector('meta[name="robots"]')

  if (!robotsTag) {
    robotsTag = document.createElement('meta')
    robotsTag.name = 'robots'
    document.head.appendChild(robotsTag)
  }

  const isPrivatePage = to.matched.some(
    (route) => route.meta.requireLogin
  )

  robotsTag.setAttribute(
    'content',
    isPrivatePage ? 'noindex, nofollow' : 'index, follow'
  )
})

export default router